export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:error', (error) => {
    if (error instanceof TypeError && error.message?.includes('dynamically imported module')) {
      if (import.meta.client && typeof window !== 'undefined') {
        window.location.reload()
      }
    }
  })
})